import { OrderStatusEnum } from "../Services/api/orders/orders.interface";

export const labelsOrderStatus : Record<OrderStatusEnum, string> = {
    OPEN: 'Processando',
    PROCESSING: 'Em processamento',
    DEAD: 'Erro',
    CANCELING: 'Cancelando',
    CANCELED: 'Cancelado',
    COMPLETED: 'Concluído',
    AWAITING_PICKING: 'Aguardando Separação',
    IN_PICKING: 'Em Separação',
    AWAITING_INVOICING: 'Aguardando Faturamento',
    INVOICING: 'Aguardando Faturamento no OMIE',
    INVOICE_PROBLEM: 'Com Problemas de Faturamento',
    PARTIALLY_INVOICED: 'Parcialmente Faturado',
   
    INVOICED: 'Faturado',
};


export const normalizeOrderStatusTitle = (status: OrderStatusEnum): string => {
    return labelsOrderStatus[status]
}

export const normalizeOrderStatusColors = (status: OrderStatusEnum): { bgColor: string; textColor: string } => {
    const bgColor: Record<OrderStatusEnum, string> = {
        OPEN: 'rgba(255, 193, 7, 0.7)', // Amarelo
        PROCESSING: 'rgba(33, 150, 243, 0.7)', // Azul
        DEAD: 'rgba(244, 67, 54, 0.7)', // Vermelho
        CANCELING: 'rgba(255, 152, 0, 0.7)', // Laranja
        CANCELED: 'rgba(158, 158, 158, 0.7)', // Cinza
        COMPLETED: 'rgba(76, 175, 80, 0.7)', // Verde
        AWAITING_PICKING: 'rgba(103, 58, 183, 0.7)', // Roxo
        IN_PICKING: 'rgba(156, 39, 176, 0.7)', // Roxo Escuro
        AWAITING_INVOICING: 'rgba(255, 87, 34, 0.7)', // Laranja Escuro
        INVOICING: 'rgba(121, 85, 72, 0.7)', // Marrom
        INVOICE_PROBLEM: 'rgba(244, 67, 54, 0.7)', // Vermelho
        PARTIALLY_INVOICED: 'rgba(0, 150, 136, 0.7)', // Verde Água
       
        INVOICED: 'rgba(40, 85, 135, 0.7)', // Azul Escuro BILLED: 'rgba(40, 85, 135, 0.7)', // Azul Escuro (DEPRECATED)
    };

    const textColor: Record<OrderStatusEnum, string> = {
        OPEN: '#212121', // Texto escuro para fundo amarelo
        PROCESSING: '#FFFFFF', // Texto branco para fundo azul
        DEAD: '#FFFFFF', // Texto branco para fundo vermelho
        CANCELING: '#212121', // Texto escuro para fundo laranja
        CANCELED: '#212121', // Texto escuro para fundo cinza
        COMPLETED: '#FFFFFF', // Texto branco para fundo verde
        AWAITING_PICKING: '#FFFFFF', // Texto branco para fundo roxo
        IN_PICKING: '#FFFFFF', // Texto branco para fundo roxo escuro
        AWAITING_INVOICING: '#FFFFFF', // Texto branco para fundo laranja escuro
        INVOICING: '#FFFFFF', // Texto branco para fundo marrom
        INVOICE_PROBLEM: '#FFFFFF', // Texto branco para fundo vermelho
      
        PARTIALLY_INVOICED: '#FFFFFF', // Texto branco para fundo verde água
       
        INVOICED: '#FFFFFF', // Texto branco para fundo azul escuro
    };

    return {
        bgColor: bgColor[status] || 'rgba(0,0,0,0.5)',
        textColor: textColor[status] || '#FFFFFF'
    };
};
